import { Component, HostBinding, input } from '@angular/core';

@Component({
  selector: 'button[cue-toggle-button], a[cue-toggle-button]',
  imports: [],
  templateUrl: './toggle-button.component.html',
  styleUrls: ['./toggle-button.component.scss'],
})
export class ToggleButtonComponent {
  class = input('');
  public active = input(false);
  public variant = input<'primary' | 'with-image'>('primary');
  public size = input<'small' | 'tiny' | 'large'>('small');

  @HostBinding('class') get classAttribute(): string {
    let classes = [this.variant(), this.size(), this.class()].filter(Boolean).join(' ');
    if (this.active()) {
      classes += ' active ';
    }
    return classes;
  }

  @HostBinding('attr.aria-pressed') get ariaPressed() {
    return this.active()!;
  }
}
